export default __webpack_public_path__ + "images/WC.1d7ea21.png";